import React from "react";
// import { Link } from 'react-router-dom';
import {
  CardBody,
  Row,
  Col,
  ModalBody,
} from "reactstrap";
// import { history } from '_helpers';

// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";



class ReplacementPlanHelpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }



  componentDidMount() {

  }


  render() {
    const { fees } = this.props
    console.log("fees", fees)
    // let remit = num * ticket.price
    // let lvFee = remit * (liveNyteTicketPercentage/100) +
    //             num   * liveNyteTicketFlatFee
    // let stripeFee = (remit + lvFee + stripeFlatFee) / (1 - (stripePercentage/100)) - remit - lvFee
    // console.log("num", num, "remit", remit, "lvFee", lvFee, "stripeFee", stripeFee)
    console.log("ReplacementPlanHelpModal: render", this.state)

    return (
      <ModalBody>
        <Row>
          <Col xs={12}>
            <p className="text-left px-2 py-2">
              <>
                <h3 className="text-uppercase mb-1">Replacement Plans</h3>

                <h4 className="mb-2">Updating Replacement Plans</h4>
                <ul className="modal-list">
                  <li>
                    To update the price of a replacement plan, navigate to the active plan it is replacing.
                  </li>
                  <li>
                    Update both the <b>price</b> and the <b>replacement date</b>.
                  </li>
                </ul>

                <h4 className="mb-2">Deleting Replacement Plans</h4>
                <ul className="modal-list">
                  <li>
                    Emails are sent to your subscribers when a replacement plan is created, notifying them of the change.
                  </li>
                  <li>
                    Once a replacement plan is created, it <b>cannot be deleted</b>.
                  </li>
                  <li>
                    After a replacement plan takes over an active plan, it can be replaced again with a new plan.
                  </li>
                </ul>
              </>
            </p>
          </Col>
        </Row>
      </ModalBody>
    );
  }
}

function mapStateToProps(state) {
  const { feesData } = state;
  const { fees, fetchingFees } = feesData;
  return {
    fees, fetchingFees
  };
}

const connectedReplacementPlanHelpModal = connect(mapStateToProps)(ReplacementPlanHelpModal);
export { connectedReplacementPlanHelpModal as ReplacementPlanHelpModal }; 